import type { ReactNode } from 'react'
import { DetailsCard, FieldCaption, YesToggle } from './DetailsCard'

/**
 * "Is this part of a campaign?": the campaign the order belongs to and the campaign's media
 * plan. The picker and the uploads are the caller's, since both read and write campaigns.
 */
export function CampaignCard({
	isCampaign,
	onToggle,
	picker,
	mediaPlan,
	requiresAction,
	isRequired,
}: {
	isCampaign: boolean
	/** Absent when the campaign is fixed, by Workfront or by the reader's rights. */
	onToggle?: (isCampaign: boolean) => void
	picker: ReactNode
	mediaPlan: ReactNode
	requiresAction?: boolean
	/** Whether the Send Task guard requires the campaign's materials: Campaign Name and Media Plan. */
	isRequired?: boolean
}) {
	return (
		<DetailsCard
			title="Is this part of a campaign?"
			requiresAction={requiresAction}
			action={<YesToggle label="Is this part of a campaign?" isSelected={isCampaign} onChange={onToggle} />}
		>
			{isCampaign ? (
				<>
					<div className="flex flex-col gap-1">
						<FieldCaption label="Campaign Name" isRequired={isRequired} />
						{picker}
					</div>
					<div className="flex flex-col gap-2">
						<FieldCaption label="Media Plan" isRequired={isRequired} />
						{mediaPlan}
					</div>
				</>
			) : null}
		</DetailsCard>
	)
}
